import { makeCygnusApiCall } from "api/api";
import { ClientDataItem } from "./ClientsPage.types";
import type { ClientScope } from "./ClientsPage.types";
import { getClientScopePayload, getClientScopeQuery } from "./ClientsPage.utils";

/**
 * API Service for ClientsPage
 */

/**
 * Fetches the client response of all clients.
 */
export const getClients = async (scope: ClientScope = "all"): Promise<ClientDataItem[]> => {
  const allClients = await makeCygnusApiCall({
    type: "GET",
    payload: {},
    url: `/clients/${getClientScopeQuery(scope)}`,
    show_message: false,
    customized_success_message: "Fetched Clients Data Successfully",
    customized_failure_message: "Unable to fetch clients data, please contact support and attach a screenshot.",
    isblob: false,
    path: "/tax",
    istax: true
  })
  return allClients?.data ?? [];
}


/**
 * Fetches the client response of all clients with matching ClientId or client name.
 * @param {string} clientId or clientName - The ID of the client to fetch data for.
 */
export const searchClient = async (payload: any, scope: ClientScope = "all"): Promise<ClientDataItem[]> => {
  const result = await makeCygnusApiCall({
    type: "POST",
    payload: {
      ...payload,
      ...getClientScopePayload(scope),
    },
    url: "/clients/",
    show_message: false,
    customized_success_message: "Client Search Successfull",
    customized_failure_message: "Unable to make a client search, please contact support and attach a screenshot.",
    isblob: false,
    path: "/tax",
    istax: true
  })
  return result?.data ?? [];
}
